import { Injectable } from '@angular/core';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import {
  ActivityPanelDTO,
  ActivityPanelResponseDTO,
  MacroReportRequest,
  MacroReportResponseDTO,
  MonthlyRequest,
  MonthlyResult,
  MonthlyStatusAuto,
  MonthlyStatusConsumption,
  PaymentReportPrint,
  PaymentReportRequest,
  PaymentReportsResponse,
} from '../model/activity-model';
import { ActivityService } from './activity-services.service';

@Injectable()
export class ActivityStore {
  constructor(private activityService: ActivityService) {}

  // getEstablishments(prescriptor: string) {
  //   return new Promise<CommonDataDTO[]>((resolve, reject) => {
  //     this.activityService.postGetEstablishments(prescriptor).subscribe(
  //       (data) => (data ? resolve(data) : reject(data)),
  //       (error) => reject(error)
  //     );
  //   });
  // }

  // getPrescribers() {
  //   return new Promise<CommonDataDTO[]>((resolve, reject) => {
  //     this.activityService.postGetPrescribers().subscribe(
  //       (data) => (data ? resolve(data) : reject(data)),
  //       (error) => reject(error)
  //     );
  //   });
  // }

  getPaymentReports(paymentReportRequest: PaymentReportRequest) {
    return new Promise<PaymentReportsResponse>((resolve, reject) => {
      this.activityService.postGetPaymentReports(paymentReportRequest).subscribe(
        (data) => (data ? resolve(data) : reject(data)),
        (error) => reject(error)
      );
    });
  }

  getPdfPaymentReport(numOperation: string, language: string) {
    const paymentReportPrint: PaymentReportPrint = { numOperation: numOperation };
    return new Promise<any>((resolve, reject) => {
      this.activityService.postPrintPaymentReport(paymentReportPrint, language).subscribe(
        (data) => (data ? resolve(data) : reject(data)),
        (error) => reject(error)
      );
    });
  }

  getActivityPanel(activityPanelDto: ActivityPanelDTO) {
    return new Promise<ActivityPanelResponseDTO[]>((resolve, reject) => {
      this.activityService.postGetActivityPanel(activityPanelDto).subscribe(
        (data) => (data ? resolve(data) : reject(data)),
        (error) => reject(error)
      );
    });
  }

  getStatus() {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.activityService.postGetStatus().subscribe(
        (data) => (data ? resolve(data) : reject(data)),
        (error) => reject(error)
      );
    });
  }

  getMacros(activityMacro: MacroReportRequest): Promise<MacroReportResponseDTO[]> {
    return new Promise<MacroReportResponseDTO[]>((resolve, reject) => {
      this.activityService.postGetActivityMacros(activityMacro).subscribe(
        (data) => (data ? resolve(data) : reject(data)),
        (error) => reject(error)
      );
    });
  }

  getMacrosExcel(activityMacro: MacroReportRequest): Promise<MacroReportResponseDTO[]> {
    return new Promise<MacroReportResponseDTO[]>((resolve, reject) => {
      this.activityService.postGetActivityMacrosExcel(activityMacro).subscribe(
        (data) => (data ? resolve(data) : reject(data)),
        (error) => reject(error)
      );
    });
  }

  getMonthlyAutosReport = (request: MonthlyRequest): Promise<MonthlyResult[]> => {
    return new Promise<MonthlyResult[]>((resolve, reject) => {
      this.activityService.postGetMontlyAutosReport(request).subscribe(
        (data) => {
          if (data?.length > 0) {
            const result: MonthlyResult[] = [];
            data.forEach((item) => {
              const index = result.findIndex((resultItem) => resultItem.agentPk === item.agentPk);
              let monthlyStatus: MonthlyStatusAuto = {
                state: item?.state,
                p10: item?.p10,
                p15: item?.p15,
                p20: item?.p20,
                p30: item?.p30,
                p40: item?.p40,
                total: item?.total,
                financed: item?.financed,
                incAgent: item?.incAgent,
                incSeller: item?.incSeller,
                losses: item?.losses,
                ppb: item?.ppb,
                ppt: item?.ppt,
                incProtections: item?.incProtections,
              };

              index >= 0
                ? result[index].statusAuto?.push(monthlyStatus)
                : result.push({ pageTotal: item.pageTotal, agentPk: item.agentPk, statusAuto: [monthlyStatus] });
            });
            resolve(result);
          } else reject(data);
        },
        (error) => reject(error)
      );
    });
  };

  getMonthlyConsumptionReport = (request: MonthlyRequest): Promise<MonthlyResult[]> => {
    return new Promise<MonthlyResult[]>((resolve, reject) => {
      this.activityService.postGetMontlyConsumptionReport(request).subscribe(
        (data) => {
          if (data?.length > 0) {
            const result: MonthlyResult[] = [];
            data.forEach((item) => {
              const index = result.findIndex((resultItem) => resultItem.agentPk === item.agentPk);
              let monthlyStatus: MonthlyStatusConsumption = {
                state: item?.state,
                p10: item?.p10,
                p30: item?.p30,
                total: item?.total,
                financed: item?.financed,
                ppt: item?.ppt,
              };
              index >= 0
                ? result[index].statusConsumption?.push(monthlyStatus)
                : result.push({
                    pageTotal: item.pageTotal,
                    agentPk: item.agentPk,
                    statusConsumption: [monthlyStatus],
                  });
            });
            resolve(result);
          } else reject(data);
        },
        (error) => reject(error)
      );
    });
  };
}
